(function () {

    function init() {

        const printButton = document.getElementById("print-bra-report");
        const pdfButton = document.getElementById("download-bra-report");

        if (printButton) {
            printButton.addEventListener("click", printReport);
        }

        if (pdfButton) {
            pdfButton.addEventListener("click", downloadPDF);
        }

        console.log("Bra Report Module Initialised");

    }

function buildReportData() {

    if (!window.braAssessment) {
        console.error("Bra assessment not found.");
        return null;
    }

    const assessment = window.braAssessment.assessmentData;

    const recommendationResults =
        window.braAssessment.generateRecommendations();

    return {

        generatedAt: new Date(),

        assessment: {
            bustSize: assessment.bustSize,
            shape: assessment.shape,
            tissue: assessment.tissue,
            fullness: assessment.fullness,
            lifeStage: assessment.lifeStage,

            concerns: [...assessment.concerns],
            lifestyle: [...assessment.lifestyle],
            preferences: [...assessment.preferences]
        },

        recommendations: recommendationResults,

        recommendationDescriptions:
            window.braAssessment.recommendationDescriptions,

        fitChecks:
            window.braAssessment.universalFitChecks,

        problemAdvice:
            window.braAssessment.problemAdvice

    };

}


function buildHeader(report) {

    const formattedDate = report.generatedAt.toLocaleDateString(
        "en-AU",
        {
            day: "numeric",
            month: "long",
            year: "numeric"
        }
    );

    return `

<div class="report-header">

    <img
        class="report-logo"
        src="https://cdn.shopify.com/s/files/1/0627/5288/2946/files/The_foundation_logo_in_teal.png?v=1782450843"
        alt="The Foundation">

    <h1>
        Your Personal Bra Fit Report
    </h1>

    <p class="report-subtitle">
        Based on your shape, support needs and preferences, here are the features and solutions that may suit you best.
    </p>

    <p>
        Generated: ${formattedDate}
    </p>

</div>

`;

}

function buildJourney(report) {

    const assessment = report.assessment;

    return `

<section class="report-section">

    <h2>
        Your Journey Summary
    </h2>

    <div class="journey-grid">

        <div class="report-card">

            <h3>Bust Type</h3>

            <ul>

                <li>${assessment.bustSize || "-"}</li>

                <li>${assessment.shape || "-"}</li>

                <li>${assessment.tissue || "-"}</li>

                <li>${assessment.fullness || "-"}</li>

                <li>${assessment.lifeStage || "-"}</li>

            </ul>

        </div>

        <div class="report-card">

            <h3>Bra Concerns</h3>

            <ul>

                ${assessment.concerns
                    .map(item => `<li>${item}</li>`)
                    .join("")}

            </ul>

        </div>

        <div class="report-card">

            <h3>Lifestyle</h3>

            <ul>

                ${assessment.lifestyle
                    .map(item => `<li>${item}</li>`)
                    .join("")}

            </ul>

        </div>

        <div class="report-card">

            <h3>Preferences</h3>

            <ul>

                ${assessment.preferences
                    .map(item => `<li>${item}</li>`)
                    .join("")}

            </ul>

        </div>

    </div>

</section>

`;

}

function buildRecommendations(report) {

    const recommendationResults = report.recommendations;

    const recommendations = recommendationResults.recommendations;

    const topRecommendations =
        recommendations.slice(0, 5);

    const remainingRecommendations =
        recommendations.slice(5);

    return `

<section class="report-section">

    <h2>
        Your Recommended Features
    </h2>
    
${topRecommendations.map(item => {

    const title = item[0];

    const score = item[1];

    const info =
        report.recommendationDescriptions[title];

    let matchLabel = "Recommended";

    if (score >= 3) {

        matchLabel = "⭐ Top Match";

    }
    else if (score >= 2) {

        matchLabel = "✓ Highly Recommended";

    }

    return `

<div class="recommendation-card">

    <div class="recommendation-header">

        <h3>${title}</h3>

<span class="match-score">
    ${matchLabel}
</span>

    </div>

    <p class="recommendation-description">

        ${info?.description || ""}

    </p>

    <div class="recommendation-benefit">

        <strong>Benefit</strong>

        <p>

            ${info?.benefit || ""}

        </p>

    </div>

</div>

`;

}).join("")}

${remainingRecommendations.length ? `

<div class="additional-recommendations">

    <h3>
        Other Features That May Suit You
    </h3>

    <ul>

        ${remainingRecommendations.map(item => `
            <li>${item[0]}</li>
        `).join("")}

    </ul>

</div>

` : ""}

</section>

`;

}

function buildFitChecks(report) {

    const fitChecks = Object.values(report.fitChecks || {});

    if (!fitChecks.length) {
        return ``;
    }

    return `

<section class="report-section">

    <h2>
        Important Fit Checks
    </h2>

    <p class="report-section-intro">
        Before changing your bra style or size, review these important fit points.
    </p>

    <div class="fit-check-grid">

        ${fitChecks.map(check => `

            <div class="fit-check-card">

                <h3>
                    ${check.title}
                </h3>

                <p>
                    ${check.explanation}
                </p>

                <div class="fit-check-importance">

                    <strong>
                        Why it matters
                    </strong>

                    <p>
                        ${check.whyItMatters}
                    </p>

                </div>

            </div>

        `).join("")}

    </div>

</section>

`;

}

function buildProblemAdvice(report) {

    const assessment = report.assessment;

    console.log("Selected concerns:");
    console.log(assessment.concerns);

    const advice = report.problemAdvice || {};

        if (!assessment.concerns.length) {
         return ``;
        }

    return `

<section class="report-section">

    <h2>
        Guidance for Your Bra Concerns
    </h2>

    <p class="report-section-intro">
        Based on the concerns you selected, here are some additional fitting tips and guidance.
    </p>

    <div class="problem-advice-grid">

        ${assessment.concerns.map(problem => {

            const problemKeyMap = {

                "Side Spillage / Overflow": "Cups Overflowing"

            };

            const adviceKey =
                problemKeyMap[problem] || problem;

         const item =
              advice[adviceKey];

console.log(problem);
console.log(adviceKey);
console.log(item);              

            if (!item) return "";

            return `

<div class="problem-advice-card">

    <h3>
        ${problem}
    </h3>

    <p class="problem-commentary">

        ${item.commentary}

    </p>

    <div class="problem-list">

        <strong>
            Possible causes
        </strong>

        <ul>

            ${item.causes.map(cause => `
                <li>${cause}</li>
            `).join("")}

        </ul>

    </div>

    <div class="problem-list">

        <strong>
            What you can do
        </strong>

        <ul>

            ${item.solutions.map(solution => `
                <li>${solution}</li>
            `).join("")}

        </ul>

    </div>

</div>

`;

        }).join("")}

    </div>

</section>

`;

}

function buildDisclaimer() {

    return `

<section class="report-section">

    <div class="report-disclaimer">

        <h2>
            Disclaimer
        </h2>

        <p>

            This report is designed to provide general bra fitting guidance based on your responses. Every body is unique, and this assessment does not replace a professional bra fitting.

        </p>

        <p>

            If you continue to experience discomfort or are unsure of your fit, we recommend visiting <strong>The Foundation</strong> for a personalised bra fitting with one of our experienced fitting specialists.

        </p>

    </div>

</section>

`;

}

function buildNeedHelp() {

    return `

<section class="report-section">

    <div class="need-help-card">

        <h2>
            Need More Help?
        </h2>

        <p>

            If you're still unsure about your fit or would like personalised advice, our experienced bra fitting specialists are here to help.

        </p>

        <p>

            Visit <strong>The Foundation</strong> in-store or contact our team for a professional bra fitting tailored to your unique shape and needs.

        </p>

    </div>

</section>

`;

}

function getReportStyles() {

    return `

<style>

@import url('https://fonts.googleapis.com/css2?family=Jost:wght@300;400;500;600&family=Playfair+Display:wght@500;600;700&display=swap');

*{
    box-sizing:border-box;
}

body{
    margin:0;
    padding:0;
    background:#ffffff;
}

.bra-report{

    width:100%;

    max-width:794px;

    margin:0 auto;

    background:#fff;

    border-radius:14px;

    padding:32px;

}

.report-header{

    border-bottom:2px solid #e4ddd7;

    margin-bottom:40px;

    padding-bottom:25px;

}

.report-header h1{

    font-family:'Playfair Display',serif;

    margin:0;

    color:#436066;

    font-size:40px;

    text-align:center;

}

.report-header p{

    margin-top:12px;

    color:#777;

    text-align:center;

    font-size:15px;

}

.report-logo{

    display:block;

    width:220px;

    margin:0 auto 30px;

}

.report-section{

    margin-top:45px;

}

.report-section h2{

    font-family:'Playfair Display',serif;

    color:#436066;

    font-size:30px;

    margin-bottom:25px;

}

.report-card h3{

    font-family:'Playfair Display',serif;

    color:#436066;

    margin-top:0;

}

.journey-grid{

    display:grid;

    grid-template-columns:repeat(2,1fr);

    gap:32px;

    align-items:stretch;

}

.report-card{

    background:#faf8f6;

    border:1px solid #e7ddd6;

    border-radius:12px;

    padding:30px;

    display:flex;

    flex-direction:column;

    justify-content:flex-start;

    height:100%;

}

.report-card h3{

    margin-top:0;

    margin-bottom:18px;

    color:#436066;

    font-size:22px;

    font-family:'Playfair Display',serif;

}

.report-card ul{

    margin:0;

    padding-left:20px;

}

.report-card li{

    margin-bottom:8px;

}

@media (max-width:768px){

    .journey-grid{

        grid-template-columns:1fr;

    }

}

.report-subtitle{

    max-width:650px;

    margin:18px auto;

    text-align:center;

    color:#666;

    font-size:17px;

    line-height:1.7;

}

.recommendation-card{

    background:#ffffff;

    border:1px solid #d8cfc8;

    border-left:6px solid #436066;

    border-radius:12px;

    padding:28px;

    margin-bottom:24px;

    box-shadow:0 4px 12px rgba(0,0,0,.05);

}

.recommendation-header{

    display:flex;

    justify-content:space-between;

    align-items:center;

    margin-bottom:18px;

    gap:20px;

}

.recommendation-header h3{

    margin:0;

    color:#436066;

    font-size:24px;

    font-family:'Playfair Display',serif;

}

.match-score{

    background:#EAF2F1;

    color:#436066;

    padding:8px 16px;

    border-radius:999px;

    font-size:14px;

    font-weight:600;

}

.recommendation-description{

    margin-bottom:20px;

    line-height:1.8;

}

.recommendation-benefit{

    background:#F8F3EF;

    border-radius:10px;

    padding:18px;

}

.recommendation-benefit strong{

    color:#436066;

}

.additional-recommendations{

    margin-top:40px;

    background:#F8F3EF;

    border-radius:12px;

    padding:24px;

}

.additional-recommendations h3{

    margin-top:0;

    color:#436066;

    font-family:'Playfair Display',serif;

}

.additional-recommendations ul{

    columns:2;

    margin:0;

    padding-left:20px;

}

.report-section-intro{
    max-width:760px;
    margin:-10px 0 28px;
    color:#666;
    line-height:1.7;
}

.fit-check-grid{
    display:grid;
    grid-template-columns:repeat(2,minmax(0,1fr));
    gap:22px;
}

.fit-check-card{
    background:#ffffff;
    border:1px solid #e1d8d1;
    border-radius:12px;
    padding:24px;
    break-inside:avoid-page;
    page-break-inside:avoid;
}

.fit-check-card h3{
    margin:0 0 14px;
    color:#436066;
    font-family:'Playfair Display',serif;
    font-size:21px;
}

.fit-check-card > p{
    margin:0 0 18px;
    line-height:1.7;
}

.fit-check-importance{
    background:#F8F3EF;
    border-radius:9px;
    padding:16px;
}

.fit-check-importance strong{
    color:#436066;
}

.fit-check-importance p{
    margin:8px 0 0;
    line-height:1.6;
}

@media (max-width:768px){

    .fit-check-grid{
        grid-template-columns:1fr;
    }

}
 
.fit-check-importance{

    background:#F8F3EF;

    border-left:4px solid #436066;

    border-radius:8px;

    padding:12px 16px;

}

.problem-advice-grid{

    display:grid;

    grid-template-columns:repeat(2,minmax(0,1fr));

    gap:22px;

}

.problem-advice-card{

    background:#ffffff;

    border:1px solid #e1d8d1;

    border-radius:12px;

    padding:24px;

    break-inside:avoid;

    page-break-inside:avoid;

}

.problem-advice-card h3{

    margin:0 0 14px;

    color:#436066;

    font-family:'Playfair Display',serif;

    font-size:21px;

}

.problem-advice-card p{

    margin:0;

    line-height:1.7;

}

@media (max-width:768px){

    .problem-advice-grid{

        grid-template-columns:1fr;

    }

}

.problem-commentary{

    margin-bottom:20px;

    line-height:1.8;

}

.problem-list{

    margin-top:18px;

    background:#F8F3EF;

    border-radius:10px;

    padding:18px;

}

.problem-list strong{

    color:#436066;

}

.problem-list ul{

    margin:12px 0 0;

    padding-left:20px;

}

.problem-list li{

    margin-bottom:8px;

}

.report-disclaimer{

    margin-top:50px;

    background:#F8F3EF;

    border-left:6px solid #436066;

    border-radius:12px;

    padding:28px;

}

.report-disclaimer h2{

    margin-top:0;

    color:#436066;

    font-family:'Playfair Display',serif;

    font-size:28px;

}

.report-disclaimer p{

    margin:14px 0;

    line-height:1.8;

    color:#555;

}    

.need-help-card{

    background:#436066;

    color:#ffffff;

    border-radius:14px;

    padding:36px;

    text-align:center;

    margin-top:20px;

}

.need-help-card h2{

    margin-top:0;

    margin-bottom:18px;

    font-family:'Playfair Display',serif;

    color:#ffffff;

    font-size:32px;

}

.need-help-card p{

    max-width:700px;

    margin:0 auto 16px;

    line-height:1.8;

    font-size:17px;

}

.need-help-card strong{

    color:#ffffff;

}

@page{
    size:A4;
    margin:14mm;
}


@media print{

    body{
        padding:0;
        background:#ffffff;
    }

    .bra-report{
        width:980px;    
        max-width:980px;
        margin:0 auto;
        padding:0;
        border-radius:0;
        box-shadow:none;
        background:#fff;
    }

    .report-header{
        margin-top:0;
    }

    .report-card,
    .recommendation-card,
    .fit-check-card,
    .problem-advice-card,
    .additional-recommendations,
    .report-disclaimer,
    .problem-list,
    .fit-check-importance{
        break-inside:avoid;
        page-break-inside:avoid;
    }

    .report-section h2,
    .recommendation-header,
    .problem-advice-card h3,
    .fit-check-card h3{
        break-after:avoid;
        page-break-after:avoid;
    }

    .report-section{
        margin-top:32px;
    }

    .recommendation-card{
        box-shadow:none;
    }

.journey-grid{
    display:grid !important;
    grid-template-columns:repeat(2,1fr) !important;
    gap:28px;
}

.fit-check-grid{
    display:grid !important;
    grid-template-columns:repeat(2,1fr) !important;
    gap:22px;
}

.problem-advice-grid{
    display:grid !important;
    grid-template-columns:repeat(2,1fr) !important;
    gap:22px;


}
 
.report-header{
    break-after:avoid-page;
    page-break-after:avoid;
}
}

</style>

`;

}

function buildReportHtml(report) {

    return `

<div class="bra-report">

    ${buildHeader(report)}

    ${buildJourney(report)}

    ${buildRecommendations(report)}

    ${buildFitChecks(report)}

    ${buildProblemAdvice(report)}

    ${buildDisclaimer()}

    ${buildNeedHelp()}

</div>

`;

}

function printReport() {

    const report = buildReportData();

    if (!report) {
        return;
    }

    const html = buildReportHtml(report);

    const preview = window.open("", "_blank");

    if (!preview) {
        alert("Please allow pop-ups to print your report.");
        return;
    }

    preview.document.open();

    preview.document.write(`
<!DOCTYPE html>
<html lang="en">

<head>

    <meta charset="UTF-8">

    <meta
        name="viewport"
        content="width=device-width, initial-scale=1">

    <title>Your Personal Bra Fit Report</title>

    ${getReportStyles()}

</head>

<body>

    ${html}

</body>

</html>
`);

    preview.document.close();

    preview.onload = function() {

        const fontsReady = preview.document.fonts
            ? preview.document.fonts.ready
            : Promise.resolve();

        fontsReady.then(function() {

            const images = Array.from(
                preview.document.querySelectorAll("img")
            );

            const imagesReady = Promise.all(
                images.map(function(image) {

                    if (image.complete) {
                        return Promise.resolve();
                    }

                    return new Promise(function(resolve) {
                        image.onload = resolve;
                        image.onerror = resolve;
                    });

                })
            );

            imagesReady.then(function() {

                setTimeout(function() {

                    preview.focus();
                    preview.print();

                }, 300);

            });

        });

    };

}
function downloadPDF() {

    const report = buildReportData();

    if (!report) {
        return;
    }

    const html = buildReportHtml(report);

    const preview = window.open("", "_blank");

    if (!preview) {
        alert("Please allow pop-ups.");
        return;
    }

    preview.document.open();

    preview.document.write(`
<!DOCTYPE html>
<html lang="en">

<head>

<meta charset="UTF-8">Your Personal Bra Fit Report

<meta
    name="viewport"
    content="width=device-width, initial-scale=1">


${getReportStyles()}

</head>

<body>

${html}

<script>

window.onload = async function(){

    if(document.fonts){

        await document.fonts.ready;

    }

    const images =
        Array.from(document.images);

    await Promise.all(

        images.map(image=>{

            if(image.complete){

                return Promise.resolve();

            }

            return new Promise(resolve=>{

                image.onload = resolve;

                image.onerror = resolve;

            });

        })

    );

    setTimeout(function(){

        window.print();

    },300);

}

</script>

</body>

</html>
`);

    preview.document.close();

}

init();

})();